import { Box, Stack, Typography, Button, Divider } from "@mui/material";

export default function HistorialCompras({ store, leadId, onNuevaVenta }) {
  const ventas = store.ventas.filter(v => v.leadId === leadId && !v.anulada).sort((a, b) => b.fecha.localeCompare(a.fecha));
  const total = ventas.reduce((s, v) => s + Number(v.total || 0), 0);
  const ids = new Set(ventas.filter(v => v.esCredito).map(v => v.id));
  const cobrado = ventas.filter(v => !v.esCredito).reduce((s, v) => s + Number(v.total || 0), 0) +
    (store.pagosCredito || []).filter(p => ids.has(p.ventaId)).reduce((s, p) => s + Number(p.monto || 0), 0);
  return <Box sx={{ my: 2, p: 2, border: 1, borderColor: "divider", borderRadius: 2 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
      <Typography fontWeight={700}>Compras ({ventas.length})</Typography>
      {onNuevaVenta && <Button size="small" onClick={() => onNuevaVenta(leadId)}>Nueva venta / recompra</Button>}
    </Stack>
    <Typography color="success.main" fontWeight={700}>LTV · {store.config.moneda} {total.toLocaleString()}</Typography>
    <Typography variant="caption" color="text.secondary">Total vendido, sin anulaciones · Cobrado: {store.config.moneda} {cobrado.toLocaleString()}</Typography>
    <Stack spacing={1} sx={{ mt: 1, maxHeight: 240, overflowY: "auto" }} divider={<Divider />}>
      {ventas.map(v => <Box key={v.id}>
        <Typography variant="body2" fontWeight={600}>{new Date(v.fecha).toLocaleDateString()} · {store.config.moneda} {Number(v.total).toLocaleString()}</Typography>
        {v.items?.length ? v.items.map((it, index) => <Typography key={index} variant="caption" display="block">{it.productoNombre} × {it.cantidad} · {store.config.moneda} {Number(it.precioUnitario).toLocaleString()} c/u</Typography>) : <Typography variant="caption">{v.productoNombre || "Venta"}</Typography>}
      </Box>)}
      {!ventas.length && <Typography variant="body2" color="text.secondary">Todavía no tiene compras.</Typography>}
    </Stack>
  </Box>;
}
